import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import {
  getLeaderboardList,
  getLeaderboardOverview,
  setLeaderboardId,
  showProgress,
} from '../../../redux/actions/DealershipActions';

const useFetchList = () => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [overview, setOverview] = useState([]);
  const [details, setDetails] = useState([]);

  const getDetails = useCallback(
    async (id) => {
      try {
        dispatch(showProgress(true));
        const res = await service.get(apiEndpoints.LB_DETAILS.replace('ID', id));
        setDetails(res);
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const getOverview = useCallback(
    async (id) => {
      try {
        dispatch(showProgress(true));
        const res = await service.get(apiEndpoints.LB_OVERVIEW.replace('ID', id));
        setOverview(res);
        dispatch(setLeaderboardId(id));
        dispatch(getLeaderboardOverview(res));
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );
  const getList = useCallback(
    async (initial = true) => {
      try {
        dispatch(showProgress(true));
        const res = await service.get(apiEndpoints.LB_FETCH);
        setList(res);
        dispatch(getLeaderboardList(res));
        if (initial) {
          getOverview(res[0]?.id);
          dispatch(setLeaderboardId(res[0]?.id));
        }
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch, getOverview],
  );

  return { list, overview, details, getOverview, getDetails, getList };
};
export default useFetchList;
